(function () {
  const showPopup = sessionStorage.getItem("fcraPopupShown") !== "true";
  const fcraOverlay = document.querySelector(".fcra-overlay");
  const fcraPopup = document.querySelector(".fcra-popup");
  const searchResults = document.querySelectorAll(".result-row");

  if (showPopup) {
    fcraOverlay.classList.remove("removed");
    fcraPopup.classList.remove("removed");
    searchResults.forEach((result) => {
      result.classList.add("blurred");
    });
  }

  const agreeCheckbox = document.getElementById("agree-checkbox");
  if (agreeCheckbox) {
    const continueBtn = document.getElementById("continue-btn");
    agreeCheckbox.addEventListener("change", function () {
      continueBtn.disabled = !this.checked;
    });

    setTimeout(() => {
      if (!agreeCheckbox.checked) {
        agreeCheckbox.checked = true;
        continueBtn.disabled = false;
      }
    }, 500);

    continueBtn.addEventListener("click", function () {
      if (!agreeCheckbox.checked) {
        return;
      }
      fcraPopup.remove();
      fcraOverlay.remove();
      searchResults.forEach((result) => {
        result.classList.remove("blurred");
      });
      sessionStorage.setItem("fcraPopupShown", "true");
    });
  }
})();
